import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {isAuthenticated} from '../client/helpers/AuthHelper';
import { path_login, path_tier3 } from '../routes/Pathnames';

const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={(props) => (
            isAuthenticated()
            ? <Component {...props} />
            : <Redirect to={{
                pathname: path_login,
            }}/>
        )}/>
    )
}
  
const PublicRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={(props) => (
            !isAuthenticated()
            ? <Component {...props} />
            : <Redirect to={{
                pathname: path_tier3,
            }}/>
        )}/>
    )
}

export{
    PrivateRoute,
    PublicRoute
}
